import { AppEnumValues } from "@shared-database/enums";
import { User } from "@shared-database/models/user";
import { sharedSchema } from "@shared-database/pgSchema";
import { leoEnum, leoID, leoNotNullForeignID } from "@shared-database/utils";
import { date, index, unique, text } from "drizzle-orm/pg-core";

const appEnum = leoEnum("App", AppEnumValues);

export const AdminDebugAccess = sharedSchema.table(
  "AdminDebugAccess",
  {
    // Properties
    id: leoID("id"),
    app: appEnum("app").notNull(),
    workspaceId: text("workspaceId").notNull(),
    date: date("date", { mode: "date" }).defaultNow().notNull(),

    // References
    ownerId: leoNotNullForeignID("ownerId").references(() => User.id, {
      onDelete: "no action",
    }),
  },
  (table) => [
    index("User_idIdx").on(table.ownerId),
    unique().on(table.app, table.workspaceId, table.date, table.ownerId),
  ],
);
